"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get RELATIVE_PARTICIPANT_LABELS () {
        return RELATIVE_PARTICIPANT_LABELS;
    },
    get ReviewAssignmentAuthor () {
        return ReviewAssignmentAuthor;
    },
    get ReviewAssignmentSigner () {
        return ReviewAssignmentSigner;
    },
    get ReviewAssignmentSignerWithLabel () {
        return ReviewAssignmentSignerWithLabel;
    },
    get ReviewAssignmentSingularParticipant () {
        return ReviewAssignmentSingularParticipant;
    },
    get contributorsId () {
        return contributorsId;
    },
    get contributorsLabel () {
        return contributorsLabel;
    },
    get directReportsId () {
        return directReportsId;
    },
    get directReportsLabel () {
        return directReportsLabel;
    },
    get managerId () {
        return managerId;
    },
    get managerLabel () {
        return managerLabel;
    },
    get managerManagerId () {
        return managerManagerId;
    },
    get managerManagerLabel () {
        return managerManagerLabel;
    },
    get otherId () {
        return otherId;
    },
    get otherLabel () {
        return otherLabel;
    },
    get selfId () {
        return selfId;
    },
    get selfLabel () {
        return selfLabel;
    }
});
const _zod = /*#__PURE__*/ _interop_require_default(require("zod"));
const _utilsisomorphic = require("@performyard/utils-isomorphic");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const selfId = "self";
const selfLabel = "Employee being reviewed";
const managerId = "manager";
const managerLabel = "Employee's manager";
const managerManagerId = "manager-manager";
const managerManagerLabel = "Manager's manager";
const otherId = "other";
const otherLabel = "Other employee";
const contributorsId = "contributors";
const contributorsLabel = "Contributors";
const directReportsId = "direct-reports";
const directReportsLabel = "Direct reports";
const RELATIVE_PARTICIPANT_LABELS = {
    [selfId]: selfLabel,
    [managerId]: managerLabel,
    [managerManagerId]: managerManagerLabel,
    [otherId]: otherLabel,
    [contributorsId]: contributorsLabel,
    [directReportsId]: directReportsLabel
};
/**
 * Singular review participant assignment options relative to the subject.
 */ const ReviewAssignmentSingularRelativeParticipant = _zod.default.enum([
    selfId,
    managerId,
    managerManagerId,
    otherId
]);
const ReviewAssignmentSingularParticipant = ReviewAssignmentSingularRelativeParticipant.or(_utilsisomorphic.transformObjectId);
const ReviewAssignmentSigner = ReviewAssignmentSingularParticipant.or(_zod.default.literal(contributorsId));
const ReviewAssignmentAuthor = ReviewAssignmentSigner.or(_zod.default.literal(directReportsId));
const ReviewAssignmentSignerWithLabel = _zod.default.union([
    _zod.default.object({
        id: _utilsisomorphic.transformObjectId,
        name: _zod.default.string()
    }),
    _zod.default.object({
        id: _zod.default.literal(selfId),
        name: _zod.default.literal(selfLabel)
    }),
    _zod.default.object({
        id: _zod.default.literal(managerId),
        name: _zod.default.literal(managerLabel)
    }),
    _zod.default.object({
        id: _zod.default.literal(managerManagerId),
        name: _zod.default.literal(managerManagerLabel)
    }),
    _zod.default.object({
        id: _zod.default.literal(otherId),
        name: _zod.default.literal(otherLabel)
    }),
    _zod.default.object({
        id: _zod.default.literal(contributorsId),
        name: _zod.default.literal(contributorsLabel)
    })
]);
